"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DropMenu = require("./partials/DropMenu");
var _Footer = require("./partials/Footer");
var _Menu = require("./Menu.styles");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox = require("../../Layout/OffsetBox/useOffsetBox");
var _Button = require("../Button");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _Card = require("../Card");
var _Header = require("./partials/Header");
var _Portal = require("../../Layout/Portal");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Menu = exports.Menu = /*#__PURE__*/(0, _react.forwardRef)((props, outerRef) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    id,
    defaultTitle,
    btnProps,
    anchorWidth = 'fit-content',
    options = undefined,
    children,
    position = 'bottom',
    isAttachedToWindow = isMobileView,
    isFullScreen = false,
    isWithActionButtons = false,
    isOpenOnFocus,
    isBoxCenteredToAnchor = false,
    onCancel,
    onConfirm,
    onBoxAnimationComplete
  } = props;
  const {
    anchorRef,
    dropContentRef,
    handleAnchorFocus,
    handleAnchorKeyUp,
    isOpen,
    toggle,
    close,
    open
  } = (0, _useOffsetBox.useOffsetBox)(isOpenOnFocus, onCancel);
  const [actualBoxPosition, setActualBoxPosition] = (0, _react.useState)(position);
  const styles = (0, _Menu.useStyles)(props, isOpen);
  const handleBoxPositionChange = pos => {
    setActualBoxPosition(pos);
  };
  (0, _react.useImperativeHandle)(outerRef, () => ({
    closeMenu() {
      close();
    },
    toggleMenu() {
      toggle();
    },
    openMenu() {
      open();
    }
  }));
  const handleCancel = (0, _react.useCallback)(event => {
    event?.stopPropagation();
    if (onCancel) {
      onCancel();
    }
    close();
  }, [close, onCancel]);
  const handleConfirm = (0, _react.useCallback)(event => {
    event?.stopPropagation();
    if (onConfirm) {
      onConfirm();
    }
    close();
  }, [close, onConfirm]);
  const handleClick = e => {
    toggle();
    if (btnProps.onClick) {
      btnProps.onClick(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Menu-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Menu'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        isCenteredToAnchor: isBoxCenteredToAnchor,
        position: position,
        isOpen: isOpen,
        onBoxPositionChange: handleBoxPositionChange,
        anchorWidth: anchorWidth,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: id ? `button-${id}` : 'ccMenuButton',
          ref: anchorRef,
          ...btnProps,
          onClick: handleClick,
          onFocus: handleAnchorFocus,
          onKeyUp: handleAnchorKeyUp
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          id: id ?? 'ccMenuDropdown',
          ref: dropContentRef,
          position: actualBoxPosition,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: btnProps?.customStyle?.width,
          onClose: isWithActionButtons ? handleCancel : close,
          onAnimationComplete: onBoxAnimationComplete,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: [isMobileView && isWithActionButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
              label: defaultTitle ?? btnProps.children,
              onCancel: handleCancel
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropMenu.DropMenu, {
              options: options,
              isFullScreen: isFullScreen,
              closeMethod: close,
              isWithActionButtons: isWithActionButtons,
              children: children
            })]
          }), isWithActionButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {
            onCancel: handleCancel,
            onConfirm: handleConfirm
          })]
        })
      })
    })]
  });
});